module.exports = require('./helpers/bundle-url').getBundleURL('4KNYk') + "logo-dark.eefe0b7f.svg";